const styles = {
  container: {},
  heading: {
    display: 'inline',
    '& h2': {
      marginBottom: '14px'
    },
    '& small': {
      color: '#a3a3a3',
      fontSize: '12px',
      fontWeight: 'normal'
    }
  },
  works: {
    margin: 0,
    padding: 0,
    overflow: 'auto',
    whiteSpace: 'nowrap',
    display: 'flex'
  },
  work: {
    textAlign: 'center',
    maxWidth: '140px',
    listStyle: 'none',
    marginRight: '12px',
    marginBottom: '10px',
    display: 'inline-block'
  },
  workTitle: {
    margin: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap'
  },
  link: {
    display: 'block',
    color: '#555',
    textDecoration: 'none',
    transition: '300ms ease-in-out',
    '&:hover': {
      opacity: '0.7'
    }
  },
  thumbnail: {
    maxWidth: '100%',
    marginBottom: '10px',
    '& > div': {
      display: 'block',
      position: 'relative',
      background: '#ececec',
      border: '1px solid #ececec',
      width: '100%',
      paddingBottom: '133%',
      borderRadius: '8px',
      overflow: 'hidden',
      '& > span': {
        position: 'absolute',
        left: '0',
        top: '0',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%'
      }
    }
  }
}

export default styles
